module.exports = __webpack_public_path__ + "img/P48-zh.eba858b9.png";